import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { Button, Tooltip } from '@mui/material'
import { LucideIcon, Plus } from 'lucide-react'
import './pageAddButton.scss'

interface PageActionButtonProps {
    id?: string
    children?: React.ReactNode
    to?: string
    href?: string
    title?: string
    label?: string
    badge?: number
    onClick?: (e: React.MouseEvent<HTMLElement>) => void
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    icon?: LucideIcon
    endIcon?: LucideIcon
    'data-userpilot'?: string
    'data-testid'?: string
}

export const PageActionButton: FC<PageActionButtonProps> = ({
    to,
    className,
    children,
    label,
    badge,
    icon: Icon,
    endIcon: EndIcon,
    ...rest
}) => {
    const iconOnly = !!label
    const button = (
        <Button
            {...rest}
            {...(to ? { component: Link, to } : {})}
            variant="outlined"
            color="secondary"
            size="medium"
            aria-label={label}
            className={classNames('page-add-button', className, { 'page-add-button--icon': iconOnly })}
            startIcon={!iconOnly && Icon && <Icon size={16} />}
            endIcon={!iconOnly && EndIcon && <EndIcon size={16} />}
        >
            {iconOnly ? Icon && <Icon size={16} /> : children}
            {iconOnly && !!badge && <span className="page-add-button__badge">{badge}</span>}
        </Button>
    )

    return iconOnly ? (
        <Tooltip title={label} placement="top">
            {button}
        </Tooltip>
    ) : (
        button
    )
}

export const PageAddButton: FC<PageActionButtonProps> = ({ icon = Plus, ...rest }) => (
    <PageActionButton icon={icon} {...rest} />
)
